import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import relativeTime from 'dayjs/plugin/relativeTime'
import timezone from 'dayjs/plugin/timezone'
import vuex from '@/store'

// Extend dayjs with plugins
dayjs.extend(utc)
dayjs.extend(relativeTime)
dayjs.extend(timezone)

const filters = {
  formatTime(time) {
    if (!time) {
      return
    }
    // Check correct time format and split into components
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time]
    if (time.length > 1) {
      // If time format correct
      time = time.slice(1) // Remove full string match value
      time[5] = +time[0] < 12 ? 'AM' : 'PM' // Set AM/PM
      time[0] = +time[0] % 12 || 12 // Adjust hours
    }
    return time.join('') // return adjusted time or original string
  },
  formatDate(date, format = 'sm', tz, convert = false, time = false) {
    let year = dayjs(date).$y
    let _ts = year > 1900 ? date : new Date().toString()
    tz = tz ?? vuex.getters.currentTimezone
    format = format ?? 'sm'
    time = time ?? false
    switch (format) {
      case 'xl':
        format = time ? 'dddd, MMMM D, YYYY h:mm A' : 'dddd, MMMM D, YYYY'
        break
      case 'lg':
        format = time ? 'ddd, MMM D, YYYY h:mm A' : 'ddd, MMM D, YYYY'
        break
      case 'md':
        format = time ? 'MMM D, YYYY h:mm A' : 'MMM D, YYYY'
        break
      case 'sm':
        format = time ? 'M/D/YYYY h:mm A' : 'M/D/YYYY'
        break
    }
    if (convert) {
      if (format == 'relative') {
        return dayjs.tz(_ts, tz).local().fromNow()
      } else {
        return dayjs.tz(_ts, tz).local().format(format)
      }
    } else {
      if (format == 'relative') {
        return dayjs.tz(_ts, tz).fromNow()
      } else {
        return dayjs.tz(_ts, tz).format(format)
      }
    }
  },
  formatSize(size) {
    if (!size) return
    // size = size * 1024
    if (size > 1024 * 1024 * 1024 * 1024) {
      return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
    } else if (size > 1024 * 1024 * 1024) {
      return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
    } else if (size > 1024 * 1024) {
      return (size / 1024 / 1024).toFixed(2) + ' MB'
    } else if (size > 1024) {
      return (size / 1024).toFixed(2) + ' KB'
    }
    return size.toString() + ' B'
  },
  truncate(text, length, clamp = '...') {
    return text.slice(0, length) + (length < text.length ? clamp || '...' : '')
  }
}

export default filters
